import { Component, OnInit , Renderer2, ElementRef} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { UserService } from '../user.service';

@Component({
  selector: 'echexpayment-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.css']
})
export class InvoiceComponent implements OnInit {
	busy: Subscription;
	public id: string;
	public token: string;
	public Downloadinvoice:number;
  

    public data;
    public filterQuery = "";
    public rowsOnPage = 10;
    public sortBy = "date";
    public sortOrder = "desc";
	public role_id: string;
	
	constructor(private router: Router, private renderer: Renderer2, private elementRef: ElementRef, private toastr: ToastrService, private userService :UserService, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService) { 
	
	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;
	let userDetails = this.localStorageService.getData("currentUser");
	this.id = userDetails._id;
	this.role_id = userDetails.role_id;
	}

	ngOnInit() {
		this.getAllInvoices();
	}
	
	ngAfterViewInit() {
		const initialSearchInput = this.elementRef.nativeElement.querySelector('#initialSearch');
		if (initialSearchInput) {
		  initialSearchInput.focus();
		}
	  }

	checkAll(ev) {
		if (ev.target.checked) {
			for(let i in this.data){
			   this.data[i].state = true;
				
		   }
		} else {
			for(let i in this.data){
			   this.data[i].state = false;
		   }
		}
	}
	// get all invoice
	getAllInvoices() {
	 var data = {
	  user_token :this.token,
	  token :this.id,
	 _id:this.id
	  }
	  let responseData = <any>{};
	 this.busy = this.echexpaymentService.getAllInvoiceData(data).subscribe(
	   response => {
		responseData = response;
		this.data = responseData.data;
	   },
	   error => {
		responseData = error;
		this.toastr.error(responseData.error.message, 'Failed!');
	   }
	);
	}
	// Download mutiple invoice
	downloadMultipleInvoice(model)
	{
		model.token = this.token;
		var invoiceIds= new Array();
		var i = 0;

		for (let key in model) {
			//console.log(key);
		if(model[key] == true)
		{
			invoiceIds[i++] = key;
		}
		}
		this.Downloadinvoice = invoiceIds.length;
		if(!invoiceIds.length)
		{
		 // Helper.echexFlashMessage(// // this.flashMessagesService.show, 'Please select at least one invoice', 'error');
		   return;
		}
		let userDetails = localStorage.getItem("currentUser");
		var userData = JSON.parse(userDetails);
		
		var data = {
		invoice_ids:invoiceIds,
		token:this.token,
		_id:userData._id
		};
		var googleWindow = window.open();
		let responseData = <any>{};
		this.busy = this.echexpaymentService.downloadMultipleInvoice(data).subscribe(
		(res) => {
			responseData = res;
			var file = new Blob([responseData], {type: "application/pdf"});
			var fileURL = URL.createObjectURL(file);
			googleWindow.location.replace(fileURL); 

		},
		error => {
			responseData = error;
			this.toastr.error(responseData.error.message, 'Failed!');
		   }
		);

	}

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/invoice/invoice.component.ts